import { makeLabels } from 'utils/i18n';

import { PayoutType } from './types';

const NAMESPACE = 'settlement.payout';
export const LABELS = makeLabels(
  {
    MODAL_TITLE: ['title', 'Set Payout'],
    PAYOUT_TYPE_LABEL: ['type.label', 'Currency Type'],
    PAYOUT_TYPE: {
      [PayoutType.Fiat]: ['type.fiat', 'Fiat'],
      [PayoutType.Crypto]: ['type.crypto', 'Crypto'],
    },
    ACTIONS: {
      CONTINUE: ['actions.continue', 'Continue'],
      CANCEL: ['actions.cancel', 'Cancel'],
      BACK: ['actions.back', 'Back'],
      ADD: ['actions.add', 'Add'],
    },
    LOADING_ASSETS_ERORR: ['errors.loadingAssets', 'An error occurred while loading assets. Please try again later.'],
  },
  NAMESPACE,
);

export const KEYS = {
  MODAL_HEADER_ID: 'payout-modal-header',
};

export default LABELS;
